
import { useEffect, useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import EmojiPicker from "../Menus/EmojiPicker";








export default function EmojiInputField({label,definition,layoutObject,updateFunc,saveFunc,screenSize}:AttributeFieldProps){

    let key = definition.attKey;
    const [showEmoji,setShowEmoji] = useState(false);

    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

    const inputRef = useRef(null);
    const emojiRef = useRef(null);
    const triggerInput =()=>{

        if(inputRef.current){
            let current = inputRef.current as HTMLInputElement;
            if(current){

                updateFunc(key,current.value,definition.targetType);

            }
        }
    }


    const clickOutside = (e:PointerEvent)=>{

        if(inputRef.current&&emojiRef.current){
            let current = inputRef.current as HTMLInputElement;
            let emoji = emojiRef.current as HTMLInputElement;
            if(current){
                if(!current.contains(e.target as Node)&&!emoji.contains(e.target as Node)){
                    setShowEmoji(false);
                }
            }
        }
    }

    const EmojiIcon =()=>{

        return <svg xmlns="http://www.w3.org/2000/svg" style={{margin:"0"}} fill="#666" height="16" width="16" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
    
    }


    useEffect(()=>{
        document.addEventListener("pointerdown",clickOutside);

        return ()=>document.removeEventListener("pointerdown",clickOutside);

    },[])




    function insert(val:string) {
        if(!inputRef.current)
            return;
        // Get a reference to the text area
        const textarea =inputRef.current as HTMLInputElement;
      
        if(textarea.value.length>=300)//don't insert at max cap
            return;
        // Get the current cursor position
        const cursorPos = textarea.selectionStart;
        if(!cursorPos){
           textarea.value+=val;
           return;
        }
      
        // Get the emoji you want to insert
        const emojiToInsert = val; // You can change this to any emoji in your array
      
        // Insert the emoji at the cursor position
        const textBeforeCursor = textarea.value.substring(0, cursorPos);
        const textAfterCursor = textarea.value.substring(cursorPos);
        textarea.value = textBeforeCursor + emojiToInsert + textAfterCursor;
        textarea.focus();
        // Move the cursor position after the inserted emoji
        textarea.setSelectionRange(cursorPos + 2, cursorPos + 2);
      }

return(

    <div className="wb-input-group">
    <label className={val==""?"not-updated":"updated"}>{label}</label>
    <div className="wb-input-row relative">
        <textarea maxLength={300} style={{height:"96px",fontSize:"16px",lineHeight:"20px"}} defaultValue={val} ref={inputRef} onInput={triggerInput} placeholder={definition.placeHolder} onChange={()=>saveFunc()}/>
        <span 
        className="invisible-button" 
        style={{position:"absolute",bottom:"8px",right:"6px",border:"none",width:"auto"}}
        onClick={()=>setShowEmoji(!showEmoji)}
        ><EmojiIcon/></span>
        {showEmoji&&
        <EmojiPicker inRef={emojiRef} onSelect={(emoji:string)=>{insert(emoji);triggerInput();}}/>
            // <div ref={emojiRef} style={{fontSize:"1.5em",maxHeight:"200px",overflow:"auto",position:"absolute",left:"0",top:"95%",width:"100%",background:"white",zIndex:"10",border:"1px solid #c7c7c7",borderRadius:"4px",padding:"4px",boxShadow:"0 4px 10px 0px #00000022"}}>
            //   {
            //         emojiArray.map((emoji,index)=>{
    
            //             return <span key={index} style={{cursor:"pointer"}} onClick={()=>{
    
            //                 if(inputRef.current){
            //                     let current = inputRef.current as HTMLInputElement;
            //                     if(current){
            //                         insert(emoji)
            //                         triggerInput();
            //                     }
            //                 }
            //             }}>{emoji}</span>
            //         })
            //   }
            //   {/* <EmojiPicker onEmojiClick={(emoji:EmojiClickData)=>{insert(emoji.emoji)}}/> */}
            // </div>
        }
    </div>
    <div className="input-description">{definition.description}</div>

  
    </div>

)
}

